import { assertNever } from '@kofno/piper';
import { ShareState, UnlicensedAccessOption } from '../Stores/ShareStore/Types';

// What happens to a course someone is not licensed for. All three let them
// join the collection; they differ in what they can do once inside.
export type UnlicensedAccess = 'block' | 'preview' | 'allocate';

export const accessFor = (unlicensedAccess: UnlicensedAccessOption): UnlicensedAccess => {
  switch (unlicensedAccess) {
    case 'read-only':
      return 'preview';
    case 'allocate':
      return 'allocate';
    case 'block':
      return 'block';
    default:
      return assertNever(unlicensedAccess);
  }
};

// The share screen only carries the setting while a collection is loaded.
export const treatmentOf = (state: ShareState): UnlicensedAccess => {
  switch (state.kind) {
    case 'ready':
    case 'searching':
    case 'reviewing':
    case 'refreshing':
    case 'publishing':
    case 'submitting':
    case 'confirming':
      return accessFor(state.unlicensedAccess);
    case 'waiting':
    case 'loading':
    case 'error':
      return 'block';
    default:
      return assertNever(state);
  }
};

export const showsPreviewCount = (access: UnlicensedAccess): boolean => {
  switch (access) {
    case 'preview':
      return true;
    case 'block':
    case 'allocate':
      return false;
    default:
      return assertNever(access);
  }
};
